import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { installChunkReloadGuard } from "./lib/version-watcher";
import { loadVendorBrands } from "./lib/brand-resolver";

// Auto-recover a stale tab that 404s on a renamed lazy chunk after a deploy
// (throttled — never loops). The matching "new version available" nudge is
// <VersionWatcher/> in App.
installChunkReloadGuard();

// Refresh the data-driven vendor brand list (public, pre-auth) into the
// localStorage cache so a registered vendor's login themes without a code
// change. Fire-and-forget — the bundled fallback covers the first paint.
void loadVendorBrands();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
